export enum DeattachEnrollmentReasonEnum {
  ANNULATION_LEC_CONTRAINTE_PRODUCTION_ETR = 'ANNULATION_LEC_CONTRAINTE_PRODUCTION_ETR',
  ANNULATION_LEC_MANQUE_EFFECTIFS_ETR = 'ANNULATION_LEC_MANQUE_EFFECTIFS_ETR',
  ANNULATION_LEC_CONTRAINTE_PRODUCTION_VOYAGE = 'ANNULATION_LEC_CONTRAINTE_PRODUCTION_VOYAGE',
  ANNULATION_LEC_MANQUE_EFFECTIFS_VOYAGE = 'ANNULATION_LEC_MANQUE_EFFECTIFS_VOYAGE',
  ANNULATION_CLIENT_SANTE = 'ANNULATION_CLIENT_SANTE',
  ANNULATION_CLIENT_PAPIERS_PERSONNELLE = 'ANNULATION_CLIENT_PAPIERS_PERSONNELLE'
}

export const deattachEnrollmentReasonEnumMapping: Record<DeattachEnrollmentReasonEnum, string> = {
  [DeattachEnrollmentReasonEnum.ANNULATION_LEC_CONTRAINTE_PRODUCTION_ETR]:
    'Annulation par LEC : contrainte production ETR',
  [DeattachEnrollmentReasonEnum.ANNULATION_LEC_MANQUE_EFFECTIFS_ETR]:
    'Annulation par LEC : manque d’effectifs ETR',
  [DeattachEnrollmentReasonEnum.ANNULATION_LEC_CONTRAINTE_PRODUCTION_VOYAGE]:
    'Annulation par LEC : contrainte production voyage',
  [DeattachEnrollmentReasonEnum.ANNULATION_LEC_MANQUE_EFFECTIFS_VOYAGE]:
    'Annulation par LEC : manque d’effectifs voyage',
  [DeattachEnrollmentReasonEnum.ANNULATION_CLIENT_SANTE]:
    'Annulation par le client - raison de santé',
  [DeattachEnrollmentReasonEnum.ANNULATION_CLIENT_PAPIERS_PERSONNELLE]:
    'Annulation par le client - papiers ou raison personnelle'
}
